module.exports = __webpack_public_path__ + "static/media/01.59017d69.jpg";